module.exports = __webpack_public_path__ + "img/solution-bg-2.7f82f7e1.png";